import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutlayout_dimuident extends Layout {
    sourceDimuidents: DataSource;
    tblDimuIdentifiers: Table;
}
